<template>
  <div class="choose-platform-wrapper">
    <h2 class="title">
      Choose Your Platform
      <VideoHoverPlayer title="Services We Provide" videoUrl="https://player.vimeo.com/video/1100304206" />
    </h2>
    <div class="step-badge">{{ stepText }}</div>

    <div class="choose-platform" role="radiogroup" aria-label="Account Type">
      <input
        id="chooseLMS"
        type="radio"
        name="platform"
        value="chooseLMS"
        v-model="modelValue"
      />
      <label for="chooseLMS" class="choose-platform-card">
        <div class="card-body">
          <h3>
            Use Our LMS
            <VideoHoverPlayer title="Manager Dashboard Tutorial Demo" videoUrl="https://player.vimeo.com/video/1107417444" />
          </h3>
        </div>
        <div class="select-dot" aria-hidden></div>
      </label>

      <input
        id="chooseOtherPlatform"
        type="radio"
        name="platform"
        value="chooseOtherPlatform"
        v-model="modelValue"
      />
      <label for="chooseOtherPlatform" class="choose-platform-card">
        <div class="card-body">
          <h3>
            License our Content
            <VideoHoverPlayer title="License Our Courses" videoUrl="https://player.vimeo.com/video/334440078" />
          </h3>
        </div>
        <div class="select-dot" aria-hidden></div>
      </label>
    </div>
  </div>
</template>

<script>
import VideoHoverPlayer from "@/components/Signup/VideoHoverPlayer.vue";
export default {
  name: "ChoosePlatform",
  components: { VideoHoverPlayer },
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  computed: {
    // ✅ Two-way binding for v-model
    modelValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    // ✅ Step badge text
    stepText() {
      if (this.modelValue === "chooseLMS") {
        return "Step 2/5";
      } else if (this.modelValue === "chooseOtherPlatform") {
        return "Step 2/5";
      }
      return "Step 2";
    },
  },
};
</script>

<style lang="scss" scoped>
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
}
a {
  text-decoration: none;
}
.choose-platform-wrapper {
  position: relative;
  margin-top: 30px;
  margin-bottom: 30px;
}

.step-badge {
  position: absolute;
  right: 0;
  top: -7px;
  background: #fff0ea;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 10px;
  line-height: 23px;
  font-weight: 700;
  color: #252525;
}
.title {
  font-size: 20px;
  line-height: 25px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #252525;
  display: flex;
  align-items: center;
  .play-icon {
    display: none;
  }
}

.choose-platform {
  display: flex;
  gap: 15px;
  align-items: stretch;

  .choose-platform-card {
    display: flex;
    align-items: center;
    flex-direction: column !important;
    flex: 1 1 0;
    min-width: 0;
    justify-content: center !important;
    gap: 18px;
    padding: 30px 16px;
    border-radius: 12px;
    border: 2px solid rgba(255, 106, 74, 0.12);
    background: #fff;
    transition: border-color 180ms ease, box-shadow 180ms ease,
      transform 120ms ease;
    position: relative;
    .card-body {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;
      color: #252525;
      h3 {
        font-size: 14px;
        line-height: 18px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        flex-wrap: nowrap;
      }
    }
    .select-dot {
      position: absolute;
      right: 12px;
      top: 12px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 2px solid rgba(200, 200, 200, 0.6);
    }
    img {
      width: 40px;
      height: 40px;
    }
  }
}

.choose-platform input[type="radio"] {
  display: none;
}
.choose-platform input[type="radio"]:checked + .choose-platform-card {
  border: 2px solid #eb1a26;
  box-shadow: 0 10px 30px rgba(255, 106, 74, 0.12);
  transform: translateY(-2px);
}
.choose-platform
  input[type="radio"]:checked
  + .choose-platform-card
  .select-dot {
  background: radial-gradient(circle at 30% 30%, #fff, #ffd6cc);
  border: 4px solid #ff6a4a;
}
@media (min-width: 768px) {
  .choose-platform-wrapper {
    margin-top: 60px;
  }
  .step-badge {
    top: 0;
    padding: 10px 14px;
    border-radius: 16px;
    font-size: 18px;
  }
  .title {
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 20px;
    .play-icon {
      color: #eb1a26;
      margin-left: 10px;
      font-size: 24px;
      display: block;
    }
  }
}

@media (min-width: 1024px) {
  .choose-platform {
    display: flex;
    gap: 24px;
    align-items: stretch;

    .choose-platform-card {
      display: flex;
      align-items: center;
      flex-direction: column !important;
      flex: 1 1 0;
      min-width: 0;
      justify-content: center !important;
      gap: 18px;
      padding: 26px;
      border-radius: 12px;
      border: 2px solid rgba(255, 106, 74, 0.12);
      background: #fff;
      transition: border-color 180ms ease, box-shadow 180ms ease,
        transform 120ms ease;
      position: relative;
      .card-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 16px;
        color: #252525;
        h3 {
          font-size: 18px;
          line-height: 23px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          flex-wrap: nowrap;
        }
      }
      .select-dot {
        position: absolute;
        right: 18px;
        top: 18px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 2px solid rgba(200, 200, 200, 0.6);
      }
      img {
        width: 40px;
        height: 40px;
      }
    }
  }
}
</style>
